export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';
export const SET_EMAIL_EXISTS = 'SET_EMAIL_EXISTS';
export const SET_DEPARTMENT_LIST = 'SET_DEPARTMENT_LIST';
export const SET_AUTHGROPUN_LIST = 'SET_AUTHGROPUN_LIST';
export const SET_MANAGER_INFO = 'SET_MANAGER_INFO';
export const SET_MANAGER_LIST = 'SET_MANAGER_LIST';
export const MANAGER_SECEDE = 'MANAGER_SECEDE';
export const MANAGER_INFO_UPDATE = 'MANAGER_INFO_UPDATE';
export const REMOVE_TWOFACTOR = 'REMOVE_TWOFACTOR';
export const RND_CHANGE_PASSWORD = 'RND_CHANGE_PASSWORD';
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const EMAIL_CHECK = 'EMAIL_CHECK';
export const DEPARTMENT_LSIT_REQUEST = 'DEPARTMENT_LSIT_REQUEST';
export const AUTHGROUP_LIST_REQUEST = 'AUTHGROUP_LIST_REQUEST';
export const MANAGER_INFO_REQUEST = 'MANAGER_INFO_REQUEST';
export const MANAGER_LIST_REQUEST = 'MANAGER_LIST_REQUEST';
export const SET_MANAGER_PAGINATION = 'SET_MANAGER_PAGINATION';
export const MANAGER_RESPONSE_MESSAGE = 'MANAGER_RESPONSE_MESSAGE';
export const MANAGER_TERMINATE_SESSION = 'MANAGER_TERMINATE_SESSION';
